import React, { useState } from 'react';
import View from '../../Utility/viewStamDuty.conatainer';

const backgroundBS = {
    boxShadow: 'rgba(0, 0, 0, 0.25) 0px 4px 18.6px 0px',
    borderRadius: '10px',
    padding: '20px',
    marginTop: '20px',
    minHeight: '400px'
}

const KycSectionStyle ={
    background: '#f4f3f1',
    padding: ' 15px',
    width:'50%',
}

const tabsType = [
    {
        name: 'KYC',
        View: 'kyc'
    },
    {
        name: 'Account Statement',
        View: 'accountStatement'
    },
]


export default function Main() {
    const [viewType, setViewType] = useState('')
    const [kycSwitches, setKycSwitches] = useState({
       type:"",value:false
    });

    const handleTabType = (type) => {
        setViewType(viewType === type ? "" : type)
    }

    const toggleSwitch = (key) => {
        setKycSwitches({
            value: kycSwitches?.type === key ? false : true,
            type:kycSwitches?.type === key ? "" : key,
        });
    };

    return (
        <>
            <div className="APIconfigurationScreens">
                <div className="container-fluid">
                    <div className="background-Bs" style={backgroundBS}>
                        <h3 className='text-center'>Configurations</h3>

                        <div className="TabsBox" style={{ display: 'flex', justifyContent: 'center', marginTop: '20px' }}>
                            {
                                tabsType?.map((value, index) => {
                                    return (
                                        <div className={`card ${viewType === value?.View ? "card-nbfc-active" : "card-nbfc"} text-center`} key={index} style={{ width: '20%', padding: '30px 0' }} onClick={() => handleTabType(value?.View)}>
                                            <b>{value?.name}</b>
                                        </div>
                                    )
                                })
                            }
                        </div>

                        <div className="configScreenType">
                        {viewType === "kyc" && (
                                <div className="switchSection" style={{ width: '40%', margin: '50px auto 0 auto', border: '10px solid #f4f3f1', borderRadius: '8px' }}>
                                    {["karza", "setu", "sure Pass"].map((key, index) => (
                                        <div className="tabss" style={{ display: 'flex', border: '5px solid #fff' }} key={index}>
                                            <div className="" style={KycSectionStyle}>
                                                <h5 style={{ fontSize: '18px', textAlign: 'center' }}>{key.charAt(0).toUpperCase() + key.slice(1)}</h5>
                                            </div>
                                            <div className="" style={KycSectionStyle}>
                                                <div className="containerSection" style={{ margin: '0 auto' }}>
                                                    <input
                                                        type="checkbox"
                                                        className="checkbox"
                                                        id={`checkbox-${key}`} // Unique ID
                                                        checked={kycSwitches.type === key}
                                                        onChange={() => toggleSwitch(key)}
                                                    />
                                                    <label className="switch" htmlFor={`checkbox-${key}`}>
                                                        <span className="slider"></span>
                                                    </label>
                                                </div>
                                            </div>
                                        </div>
                                    ))}
                                </div>
                            )}
                    </div>
                </div>
            </div>
        </div >
        </>
    )
}
